module.exports = __webpack_public_path__ + "static/media/2.dd5a404b.jpg";